export type {
  ArtifactSummary,
  ArtifactUser,
  AiReviewResult
} from 'shared/api/forgeApi'

export type { AiArtifactConfig } from 'shared/types/widgets'

export type ArtifactView = 'mini' | 'full'
